import { ProductTransferListResponseDto } from '@tiendanube/common';
import { useListDesktop } from 'App/hooks';
import { useListFilters } from 'commons/hooks';
import { CATALOG_ROUTES } from 'domains/Catalog/catalogRoutes';
import { useTransfersAutoRefresh } from './useTransfersAutoRefresh';
import { TransfersEndpoints } from '../transfersApi';

const DEFAULT_FILTERS = { page: 1 };

export function useTransfersDesktop() {
  const { filters, changeFilters } = useListFilters(
    CATALOG_ROUTES.transfers,
    DEFAULT_FILTERS,
  );

  const changePage = (page: number) => {
    changeFilters({ ...filters, page });
  };

  const result = useListDesktop<ProductTransferListResponseDto[number]>({
    filters: { ...filters, perPage: '20' },
    endpoint: TransfersEndpoints.getTransfersList,
  });

  // Use the auto-refresh hook for pending transfers
  useTransfersAutoRefresh({
    data: result.data,
    refetch: result.refetch,
  });

  return { ...result, changePage, filters };
}
